export default __webpack_public_path__ + "static/media/middle_featured_1.3db8ccc6.jpg";